
import React from 'react';
import { Link } from 'react-router-dom';
import ProductsUpload from '../../Models/ProductsUpload';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import 'rc-menu/assets/index.css';
class CategoryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
        }
        this.getCategories();
    }
    getCategories() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }
    handleClick(id) {
        this.context.router.push({ pathname: `/sub-categories/${id}` })
        // window.location.href = `/sub-categories/${id}`;
    }
    render() {
        // return (
        //     <div className="category_box_alt ml-4 pl-4">
        //         {this.state.categories.map((category, index) =>
        //             <div className="row mb-3 " key={index}>
        //                 <div className="arrow_cat"> <img src={require("../../assets/images/arrow.png")} alt="Smiley face" height="12" width='13' /> </div>
        //                 <div className="ml-2">
        //                     <div className="category-right" >{category.category}</div>
        //                 </div>
        //             </div>
        //         )}
        // const categoriesList = this.state.categoriesMenu;		
        return (
            <div style={{ fontSize: '12px' }}>
                <Menu style={{ cursor: 'pointer' }}>
                    {this.state.categories.map(data => {
                        // console.log(data)
                        if (data.sub_category.length === 0)
                            return (<MenuItem key={data.id} style={{ cursor: 'pointer' }}>
                                <Link to={{
                                    pathname: `/categories/${data.id}`,
                                    state: { id: data.id }
                                }} className="category-right" style={{ fontSize: '12px' }}>{data.category}</Link>
                            </MenuItem>)

                        return (<SubMenu title={data.category} key={data.category} style={{ paddingTop: "5px !important", paddingBottom: "5px !important" }}>
                            {data.sub_category.map((subcat) => {
                                return <MenuItem key={subcat.id} style={{ cursor: 'pointer' }}>
                                    <div
                                        // onClick={() => { this.history.push(`/sub-categories/${subcat.id}`) }}
                                        // onClick={this.handleClick.bind(this, subcat.id)}
                                        className="category-right">
                                        {/* {subcat.cat_name} */}
                                        <Link to={{ pathname: `/sub-categories/${subcat.id}` }} className="category-right">
                                            {subcat.cat_name}
                                        </Link>
                                    </div>
                                </MenuItem>
                            })}
                        </SubMenu>)
                    })}
                </Menu>
            </div>
        )
    }
}

export { CategoryList };